import { Components, Theme } from "@mui/material/styles";
import { getMenuTokens } from "./styles";

export const contextMenuGroupTitleClassName = "ContextMenuGroupTitle";

export const MuiListSubheader: Components<Theme>["MuiListSubheader"] = {
    styleOverrides: {
        root: ({ theme }) => {
            const { groupTitle } = getMenuTokens(theme);

            return {
                [`&.${contextMenuGroupTitleClassName}`]: {
                    backgroundColor: "transparent",
                    color: "inherit",
                    marginInline: groupTitle.marginInline,
                    marginBlock: groupTitle.marginBlock,
                    fontWeight: groupTitle.fontWeight,
                    fontSize: groupTitle.fontSize,
                    lineHeight: 1.5,
                },
            };
        },
    },
};
